import { Component, OnInit } from "@angular/core";
import { Organization } from "../../models/organization";
import { ApiService } from "../../lib/api.service";
import { LogService } from "../../lib/log.service";
import { ModalService } from '../../lib/modal.service';
import { UserService } from '../../lib/user.service';
import { User } from '../../models/user';
import { AnalyticEvent } from "app/lib/analytic-event";
@Component({
    selector: "app-resource-view",
    templateUrl: "./resource-view.component.html",
    styleUrls: ["./resource-view.component.scss"],
    standalone: false
})
export class ResourceView implements OnInit {
    organizations: Organization[];
    isLoaded: boolean = false;
    orgId: number;
    organization: Organization;
    title: string;
    submitButtonPressed: boolean = false;
    errors: string = "";
    formValid: boolean = false;
    resourseSet: any;
    isLoading: boolean = true;
    user: User;
    isUpdated: boolean = false;
    updatedData:any;
    extraResource:any;
    constructor(
        private userService: UserService,
        private modalService: ModalService,
        private api: ApiService,
        private log: LogService,) {
        this.user = this.userService.getUser();
    }

    ngOnInit() {
        if (this.user.userType === "admin" || this.user.userType === "superadmin" ) {
            this.api.get("admin/organizations", { Active: true }).subscribe(
                (results: any) => {
                    this.organizations = Organization.initializeArray(results.data);
                    this.isLoaded = true;
                },
                (error: any) => {
                    this.log.error("Error loading. " + error.message);
                    this.isLoaded = true;
                }
            );
        }
        else if(this.user.userType === "relationshipmanager"){
            this.api.get(`organizations/associatedinternal`).subscribe(
				(results: any) => {
					this.organizations = Organization.initializeArray(results.data);
                    this.isLoaded = true;
				},
				(error: any) => {
                    this.log.error("Error loading. " + error.message);
                    this.isLoaded = true;
				}
			);
        }
        else if (this.user.userType === "orgadmin") {
            if (this.user.organizations && this.user.organizations.length > 0) {
                this.organizations = [];
                this.organizations.push(this.user.organizations[0]);
            }

            this.api.get(`organizations/associatedorgs/${this.user.organizations[0]?.id}`).subscribe(
                (results: any) => {
                    this.organizations = Organization.initializeArray(results.data);
                    this.isLoaded = true;
                },
                (error: any) => {
                    // this.organizations = null;
                    this.isLoaded = true;
                }
            );
        }
    }

    onSelectOrganization(orgId) {
        this.orgId = orgId.value;

        this.isLoaded = false;
        this.api.get('organizations/' + orgId.value).subscribe(
            (result: any) => {
                this.organization = new Organization(result.data, 'full');
                this.resourseSet = {
                    enableResources: this.organization.enableResources,
                    language:this.organization.language,
                    resources: this.organization.resources,
                    resourceSet: this.organization.resourceSet,
                    // questionSet: this.organization.questionSet
                };
            },
            (error: any) => {
                this.log.error('Error getting organizations. ' + error.message);
                this.isLoaded = true;
            },
            () => {
                this.isLoaded = true;
            });
    }

    resourceSetChanged(data: any) {
        this.formValid = data.valid;
        this.resourseSet = data.resourceSet;
        this.extraResource = data.extraResourcesSet;
    }

    doSave() {
        this.submitButtonPressed = true;
        this.errors = "";
        this.resourseSet.resourceSet =  this.extraResource ? this.resourseSet.resourceSet.concat(this.extraResource) : this.resourseSet.resourceSet;
        if (this.resourseSet?.enableResources && this.resourseSet?.resourceSet) {
            this.resourseSet.resourceSet.every((resource: any, index: number) => {
                if (resource.title === "") {
                    this.errors = `Title of resource set ${index + 1} is empty`;
                    return false;
                }

                resource.resourcesetGroup.every((group: any, r: number) => {
                    if (group.title === "") {
                        this.errors = `Title of resourse group ${r + 1} of resource set ${index + 1} is empty`;
                        return false;
                    }

                    return true;
                });

                if (this.errors !== "") {
                    return false;
                }

                return true;
            });
        }
        
        if (this.errors === "") {
            const resourceSet = { ...this.resourseSet, resourceSet: JSON.stringify(this.resourseSet.resourceSet) };
            this.api.put('resources/update/' + this.organization.id, resourceSet, true, false).subscribe(
                (data: any) => {
                   this.updatedData = new Organization(data.data, 'full');
                    this.log.event(AnalyticEvent.event.organizationUpdated)
                    this.modalService.showAlert('Success', 'Organization has been updated');
                },
                (error: any) => {
                    this.modalService.showAlert('Error', 'Something went wrong. ' + error.message);
                }
            );
        }
    }
}
